module.exports = __webpack_public_path__ + "static/media/sports_15.bb64c620.jpg";